import React from 'react';

import {getShowUpgrade, useUserContext} from 'Contexts/UserContext/UserContext';
import {getCancelUrl, getCheckoutUrl, getPortalUrl} from 'Common/api';
import {GradientBorderButton} from 'Components/GradientBorderButton';
import {logEvent} from '@pmf/analytics';
import {ManageOrgs} from 'Containers/ManageOrgs';
import {GithubConnectionStatus} from 'Components/GithubConnectionStatus';
import {ENABLE_GITHUB_APP} from 'Common/featureFlags';

export function Manage() {
    const {userId} = useUserContext();

    return <PaidUserManagement userId={userId} />;
}

export default Manage;

export const PaidUserManagement: React.FC<React.PropsWithChildren<{userId: string}>> = ({
    userId,
}) => {
    const {user, sessionId, deviceId, availableCredits} = useUserContext();

    const customerId = user?.customer?.id;
    const paid = user?.paid;

    return (
        <div className="flex flex-col place-items-start gap-8 p-8">
            <div className="flex flex-col gap-4">
                <h1 className="text-xl font-bold text-black">Billing Portal</h1>
                <p className="text-xs font-bold text-black">
                    Available Credits: {availableCredits}
                </p>
                {customerId && (
                    <a
                        className="flex h-[35px] place-content-center rounded-lg bg-black p-2.5 text-xs font-bold text-white hover:bg-black/60 disabled:opacity-60"
                        href={getPortalUrl(customerId)}
                    >
                        <span>Go to billing portal</span>
                    </a>
                )}
                {paid && customerId && (
                    <a
                        className="flex h-[35px] place-content-center rounded-lg bg-red-500 p-2.5 text-xs font-bold text-white hover:bg-red-500/60 disabled:opacity-60"
                        href={getCancelUrl(customerId)}
                    >
                        <span>Cancel</span>
                    </a>
                )}
                {getShowUpgrade(user!, availableCredits) && (
                    <GradientBorderButton
                        className="h-[35px] rounded-lg text-xs font-bold"
                        textClassName="rounded-[6px]"
                        onClick={() => {
                            logEvent('Checkout Start', userId, {
                                data: {sessionId, deviceId},
                                user,
                            });
                            window.open(getCheckoutUrl(userId));
                        }}
                    >
                        Upgrade To Pro
                    </GradientBorderButton>
                )}
            </div>
            <div className="flex flex-col gap-4">
                <h1 className="text-xl font-bold text-black">Contact Us</h1>
                <a
                    className="text-xs font-bold text-black underline"
                    href="mailto:Caleb@tryrendition.com"
                >
                    Caleb@tryrendition.com
                </a>
            </div>
            {ENABLE_GITHUB_APP && (
                <div className="flex flex-col gap-4">
                    <h1 className="text-xl font-bold text-black">Connections</h1>
                    <GithubConnectionStatus />
                    <a
                        className="flex h-[35px] place-content-center rounded-lg bg-black p-2.5 text-xs font-bold text-white hover:bg-black/60 disabled:opacity-60"
                        href={`${process.env.REACT_APP_BACKEND_BASE_URL}/github/oauth/start?userId=${userId}`}
                    >
                        <span>Install Github App</span>
                    </a>
                </div>
            )}
            <div className="flex flex-col gap-4">
                <h1 className="text-xl font-bold text-black">Discord</h1>
                <button
                    className="flex h-[35px] place-content-center rounded-lg bg-black p-2.5 text-xs font-bold text-white hover:bg-black/60 disabled:opacity-60"
                    onClick={() => window.open('https://discord.gg/ZpaYuRTHkt')}
                >
                    <span>Join our Discord</span>
                </button>
            </div>
            {ENABLE_GITHUB_APP && <ManageOrgs />}
        </div>
    );
};
